import DMsansWoff2 from '../assets/fonts/DMSans-9ptRegular.woff2';
import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
} from '@backstage/theme';

const dmSansFont = {
  fontFamily: 'DM Sans',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('DM Sans'),
    url(${DMsansWoff2}) format('woff2')
  `,
};

export const myTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: { main: '#1F125F' },
      secondary: { main: '#1F8EBA' },
      error: { main: '#D4342C' },
      warning: { main: '#CBB933' },
      info: { main: '#E7E729' },
      success: { main: '#A5D26B' },
      background: { default: '#E8F8FF', paper: '#E8F8FF' },
      banner: {
        info: '#FFFFB6',
        error: '#B31F1F',
        text: '#1F8EBA',
        link: '#565a6e',
      },
      navigation: {
        background: '#1F125F',
        indicator: '#1F8EBA',
        color: '#E8F8FF',
        selectedColor: '#73CDF1',
      },
    },
    defaultPageTheme: 'home',
  }),
  fontFamily: 'DM Sans, sans-serif',
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@font-face': [dmSansFont],
      },
    },
  },
  pageTheme: {
    home: genPageTheme({ colors: ['#1F8EBA', '#1F8EBA'], shape: 'none' }),
    documentation: genPageTheme({ colors: ['#1F8EBA', '#1F8EBA'], shape: 'none' }),
    tool: genPageTheme({ colors: ['#1F8EBA', '#1F8EBA'], shape: 'none' }),
    service: genPageTheme({ colors: ['#1F8EBA', '#1F8EBA'], shape: 'none' }),
    website: genPageTheme({ colors: ['#1F8EBA', '#1F8EBA'], shape: 'none' }),
    library: genPageTheme({ colors: ['#1F8EBA', '#1F8EBA'], shape: 'none' }),
    other: genPageTheme({ colors: ['#1F8EBA', '#1F8EBA'], shape: 'none' }),
    app: genPageTheme({ colors: ['#1F8EBA', '#1F8EBA'], shape: 'none' }),
    apis: genPageTheme({ colors: ['#1F8EBA', '#1F8EBA'], shape: 'none' }),
  },
});
